import {membersPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import React from 'react'
import {TabsAlignment, TabsSkin, TabsVariant} from 'wix-ui-tpa/cssVars'
import {Tabs} from '../../../../../commons/enums'
import {useSettings} from '../../../../../commons/hooks/use-settings'
import {isMobile} from '../../../../../commons/selectors/environment'
import settingsParams from '../../../settingsParams'
import {useMembersPageActions, useMembersPageRuntimeContext, useMembersPageSelector} from '../../hooks/runtime'
import {getCurrentTab} from '../../selectors/tab'
import {Tabs as TabsComp} from '../styled-components/tabs'

export const EventsTabs = () => {
  const settings = useSettings()
  const {isRTL} = useMembersPageRuntimeContext()

  const tab = useMembersPageSelector(getCurrentTab)
  const mobile = useMembersPageSelector(isMobile)

  const {setTab, closeAllEvents} = useMembersPageActions()

  const onTabClick = (newTab: Tabs) => {
    setTab(newTab)
    closeAllEvents()
  }

  return (
    <TabsComp
      data-hook={DH.EVENTS_MA_PAGE_EVENT_LIST_TABS}
      items={[
        {title: settings.get(settingsParams.upcomingEventsTab)},
        {title: settings.get(settingsParams.pastEventsTab)},
      ]}
      onTabClick={onTabClick}
      alignment={mobile ? TabsAlignment.center : isRTL ? TabsAlignment.right : TabsAlignment.left}
      variant={mobile ? TabsVariant.fullWidth : TabsVariant.fit}
      skin={mobile ? TabsSkin.fullUnderline : TabsSkin.clear}
      activeTabIndex={tab}
    />
  )
}
